import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import t from '~t'
import { useSelector } from 'react-redux'
import { getSearchEmpty, makeCount } from '~data/selectors/bookmarks'
import { makeCollection } from '~data/selectors/collections'

export default function BookmarksHeaderTitle({
    spaceId = 0,
    compact = false,
    status
}) {
    const getCollection = useMemo(() => makeCollection(), [])
    const getCount = useMemo(() => makeCount(), [])

    const collection = useSelector(state => getCollection(state, spaceId))
    const isSearching = useSelector(state => !getSearchEmpty(state, spaceId))
    const count = useSelector(state => getCount(state, spaceId))

    const { _id, title = '' } = collection

    const renderTitle = () => {
        if (!_id && isSearching) {
            if (compact)
                return t.s('interest_other').toLowerCase() + ' ' + t.s('collectionsCount')
            return title.toLowerCase()
        }
        return title
    }

    if (isSearching) {
        if (status.main == 'loading') return ''
        return t.format('bookmarksFound', count)
    }

    if (compact && status.main == 'loaded') {
        return (
            <Link to={`/my/${_id}/full`}>
                {renderTitle()}
            </Link>
        )
    }

    return renderTitle()
}
